import { gql } from '@provision/graphql-client';
import { META_DATA_SEARCH_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import {
  CONVERSATION_MESSAGE_FRAGMENT,
  CONVERSATION_MESSAGE_RELATION_FRAGMENT,
} from './conversation-message.fragments';

export const GET_CONVERSATION_MESSAGES_QUERY = gql`
  query GetConversationMessage(
    $params: QueryParamsWithSearch
    $skipTotalRecords: Boolean = false
  ) @entity(name: "ConversationMessage") {
    getConversationMessage(queryParams: $params) {
      records {
        ...ConversationMessageFields
        ...ConversationMessageRelations
      }
      metadata {
        ...MetaDataSearchQueryFields
      }
    }
  }
  ${META_DATA_SEARCH_QUERY_FIELDS}
  ${CONVERSATION_MESSAGE_FRAGMENT}
  ${CONVERSATION_MESSAGE_RELATION_FRAGMENT}
`;

export const UPDATE_CONVERSATION_MESSAGE_MUTATION = gql`
  mutation UpdateConversationMessage($conversationMessageId: String!, $body: String!) {
    updateConversationMessage(
      conditions: [
        { attribute: "conversationMessageId", operator: "=", value: $conversationMessageId }
      ]
      data: { body: $body }
    ) {
      ...ConversationMessageFields
    }
  }
  ${CONVERSATION_MESSAGE_FRAGMENT}
`;

export const UPDATE_CONVERSATION_PRIVATE_MESSAGE_MUTATION = gql`
  mutation UpdateConversationPrivateMessage($params: UpdateConversationPrivateMessageInput!) {
    updateConversationPrivateMessage(params: $params) {
      ...ConversationMessageFields
    }
  }
  ${CONVERSATION_MESSAGE_FRAGMENT}
`;
